// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ONmX","label":"styles_label__2KUKC"};